<template>

    <div class="col-12 mt-4">
        <Card class="px-md-5 card-watermark" :style="`--logo-url: url(${base_url}/storage/logo.png)`">
            <template #content>
                <h2 class="mb-3 component-title">{{ tra.total_cost }}</h2>
                <hr>

                <Timeline :value="courseCalculatorResultObject" align="right" class="rtl w-full md:w-80">
                    <template #content="slotProps">
                        <div class="text-right">
                            <h3 class="course-title">{{ slotProps.item.title }}</h3>
                            <p class="course-sub-title">{{ slotProps.item.desc }}</p>
                            <div v-html="slotProps.item.price"></div>
                        </div>
                    </template>
                </Timeline>

                <hr>
                <div class="row align-items-end">
                    <div class="col-sm-6">
                        <div class="total-price d-flex align-items-sm-start align-items-center flex-column">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-file-invoice-dollar"></i>
                                <h2 class="mt-3 component-title">{{ tra.total_price }}</h2>
                            </div>
                            <div v-if="courseCalculatorResult?.total_price_before_discount == courseCalculatorResult?.total_price"
                                class="d-flex align-items-end">
                                <h2 class="mt-3 discounted-price">{{ courseCalculatorResult?.total_price }}</h2>
                            </div>
                            <div v-else class="d-flex align-items-end">
                                <del class="price">{{ courseCalculatorResult?.total_price_before_discount }}</del>
                                <h2 class="mt-3 discounted-price">{{ courseCalculatorResult?.total_price }}</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 text-sm-left text-center mt-sm-0 mt-4">
                        <book-now-component :base_url="base_url" :formInputs="formInputs" :tra="tra"></book-now-component>
                    </div>
                </div>
            </template>
        </Card>

    </div>
</template>

<script>
import Timeline from 'primevue/timeline';
import Card from 'primevue/card';
import BookNowComponent from './BookNowComponent.vue';

export default {
    components: {
        Timeline,
        Card,
        BookNowComponent,
    },
    props: ['courseCalculatorResult', 'base_url', 'formInputs', 'tra'],
    data() {
        return {

        };
    },

    computed: {
        courseCalculatorResultObject() {
            if (!this.courseCalculatorResult) return [];

            const result = this.courseCalculatorResult;
            const timelineItems = [];

            // Course item
            if (result.course) {

                let coursePrice;
                const hasDiscount = (result.course.discount_obj && result.course.discount_obj.total_discounts) ||
                    result.course.sat_discount;

                if (hasDiscount) {
                    coursePrice = `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0 mr-2">${result.course.discounted_price}</p><del class="text-danger">${result.course.price}</del></div>`;
                } else {
                    coursePrice = `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0">${result.course.price}</p></div>`;
                }

                timelineItems.push({
                    title: result.course.name,
                    desc: `${this.tra.study_for} ${result.course.name}, ${this.tra.for_duration_of} ${this.weeksOutput(result.course.course_weeks)}, ${this.tra.from} ${result.course.start_date} ${this.tra.to} ${result.course.end_date}`,
                    price: coursePrice,
                });
                
            }


            // Residence
            if (result.residence) {

                let residencePrice;
                const hasDiscount = (result.residence.discount_obj && result.residence.discount_obj.total_discounts);

                if (hasDiscount) {
                    residencePrice = `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0 mr-2">${result.residence.discounted_price}</p><del class="text-danger">${result.residence.price}</del></div>`;
                } else {
                    residencePrice = `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0">${result.residence.price}</p></div>`;
                }


                timelineItems.push({
                    title: result.residence.residence_type == "custom_accommodation" ? this.tra.residence : result.residence.residence_type,
                    desc: `${result.residence.description}, ${this.tra.for_duration_of} ${this.weeksOutput(result.residence.residence_weeks)}, ${this.tra.from} ${result.residence.start_date} ${this.tra.to} ${result.residence.end_date}`,
                    price: residencePrice,
                });
            }



            // Additional fees
            if (result.additional_fees_data && result.additional_fees_data.fees_list) {
                result.additional_fees_data.fees_list.forEach(fee => {
                    let feeTitle = fee.weeks ? `${fee.name} ${this.tra.for_duration_of} ${this.weeksOutput(fee.weeks)}` : fee.name;

                    if(fee.fees_value){
                        timelineItems.push({
                            title: feeTitle,
                            price: `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0">${fee.fees}</p></div>`,
                            desc: ''
                        });
                    }
                    
                });
            }



            // Airport transfer
            if (result.airport) {
                const isCustomAirport = result.airport.id === 'custom_airport';
                timelineItems.push({
                    title: isCustomAirport ? this.tra.airport_reception : result.airport.name,
                    price: `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0">${result.airport.price}</p></div>`,
                    desc: isCustomAirport ? result.airport.name : this.tra.airport_transfer
                });
            }

            // Insurance
            if (result.insurance && result.insurance_checker == 1) {
                timelineItems.push({
                    title: this.tra.insurance_fees,
                    price: `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0">${result.insurance}</p></div>`,
                    desc: this.tra.yes_need_insurance
                });
            }

            // Visa
            if (result.visa && result.visa_checker == 1) {
                timelineItems.push({
                    title: result.visa['name_'+window.current_locale],
                    price: `<div class="price-info d-flex align-items-end justify-content-md-end mt-2"><p class="price mb-0">${result.visa.price}</p></div>`,
                });
            }

            return timelineItems;
        }
    },

    methods: {
        weeksOutput(weeks) {
            if (!weeks || weeks === 0) {
                return this.tra.week;
            } else if (weeks == 1) {
                return this.tra.week;
            } else if (weeks == 2) {
                return this.tra.two_weeks;
            } else {
                return weeks + ' ' + this.tra.weeks;
            }
        }
    }
};
</script>





<style scoped>
.total-price i {
    font-size: 20px;
    background-color: #009994;
    color: #fff;
    padding: 5px 10px;
    border-radius: 50%;
    margin-left: 15px;
    margin-top: 6px;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.total-price .price {
    font-size: 18px;
    color: #b92e2e;
    text-decoration: line-through;
}

.total-price .discounted-price {
    font-size: 30px;
    color: #009994;
    font-weight: 700;
    margin: 0px;
    margin-right: 10px;
}

:deep(.p-timeline-event-opposite) {
    display: none !important;
}

:deep(.p-timeline-event-content) {
    padding: 15px 0px !important;
    margin: 0px 15px !important;
    border-bottom: 1px solid #f2f2f2 !important;
}

:deep(.p-timeline .p-timeline-event:first-child .p-timeline-event-content) {
    padding-top: 0px !important;
}

:deep(.p-timeline .p-timeline-event:last-child .p-timeline-event-content) {
    border-bottom: none !important;
}

:deep(.p-timeline-event-marker) {
    background-color: #009994;
    border: none;
    width: 25px;
    height: 25px;
}

:deep(.p-timeline-event-marker::after),
:deep(.p-timeline-event-marker::before) {
    display: none !important;
}


</style>

